export const _markerTypes = {
  default: 'default',
  default_dot: 'default_dot',
  default_small: 'default_small',
  dot: 'dot',
}

// https://sites.google.com/site/gmapsdevelopment/ 
// http://maps.google.com/mapfiles/ms/micons/blue-dot.png
const _markerUrl_dot = 'http://maps.google.com/mapfiles/ms/micons/COLOR-dot.png'
const _markerUrl_solid = 'https://maps.google.com/mapfiles/ms/icons/COLOR.png'
const _markerUrlSmall = 'http://labs.google.com/ridefinder/images/mm_20_COLOR.png'

export const baseMarkers = (markers, markerType, markerProps) => {
  if (markers && markers.length > 0) {
    const _markers = markers.map((marker, index) => (
      baseMarker(markerType, marker, markerProps, index + 1)
    ));
    return _markers
  }
}

const baseMarker = (markerType, marker, markerProps, index) => {

  const { mapPosition, labelText, title, geometry } = marker ?? {}
  const { location } = geometry ?? {}

  const _location = location ? {
    lat: location.lat(),
    lng: location.lng(),
  } : null

  const _mapPosition = mapPosition ? mapPosition : _location

  const baseIcon = () => {
    switch (markerType) {
      case _markerTypes.dot:
        return {
          backgroundColor: markerProps.backgroundColor,
        }
      case _markerTypes.default:
        return {
          url: _markerUrl_solid.replace('COLOR', markerProps.backgroundColor),
        }
      case _markerTypes.default_dot:
        return {
          url: _markerUrl_dot.replace('COLOR', markerProps.backgroundColor),
        }
      case _markerTypes.default_small:
        return {
          url: _markerUrlSmall.replace('COLOR', markerProps.backgroundColor),
        }
      default:
        return {
          url: _markerUrl_solid.replace('COLOR', markerProps.backgroundColor),
        }
    }
  }

  const baseMarker = () => {
    return {
      index: index,
      position: _mapPosition,
      title,
      text: labelText,
      color: markerProps.color,
      ...marker,
      ...baseIcon()
    }
  }

  return baseMarker()

}
